module.exports = __webpack_public_path__ + "img/zhinengdaoyou.09d20e11.png";